<template>
  <div class="shopPop" :value="value" v-show="showPop">
    <van-popup v-model="showFirst" position="bottom" @click-overlay="cancel">
      <van-datetime-picker
        v-model="originValue[0]"
        type="date"
        show-toolbar
        title="请选择开始时间"
        @confirm="firstChange"
        @cancel="cancel"
      />
    </van-popup>
    <van-popup v-model="showEnd" position="bottom" @click-overlay="cancel">
      <van-datetime-picker
        show-toolbar
        @confirm="endChange"
        @cancel="cancel"
        v-model="originValue[1]"
        title="请选择结束时间"
        type="date"
      />
    </van-popup>
  </div>
</template>
<script>
    export default{
        data(){
            return {
              showPop:false,
              showFirst:false,
              showEnd:false,
              originValue:[new Date(),new Date()],
              dateTime:[],
            }
        },
        props:{
          value:{
            type:Boolean,
            default:false
          },
          firstDate:'',
          endDate:'',
        },
        watch:{
          value(val){
            this.showPop = val
          },
          showPop(val){
            if(this.showPop){
                this.dateTime=[]
                this.showFirst = true
            }else{
              this.showFirst = false
              this.showEnd = false
            }
            this.$emit('input',val)
          }
        },
        methods:{
          cancel(){
            this.showPop = false
          },
          firstChange(e){
            this.showFirst=false
            this.showEnd=true
            this.dateTime.push(e)
          },
          endChange(e){
            this.dateTime.push(e)
            this.$emit('endChange',this.dateTime)
            this.showPop = false

          }
        }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">

</style>



// WEBPACK FOOTER //
// src/components/active/component/datetime.vue